<template>
  <v-snackbar
    v-model="show"
    :multi-line="mode === 'multi-line'"
    :right="true"
    :timeout="timeout"
    :top="true"
    :vertical="mode === 'vertical'"
  >
    {{ text }}
    <v-btn color="pink" flat @click="remove">{{ $t('generic.accept') }}</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  props: ['show'],
  data() {
    return {
      y: 'top',
      x: null,
      mode: '',
      timeout: 0,
      text: 'Remover todos los filtros y seleccion de tutores',
    }
  },
  methods: {
    remove() {
      this.$emit('remove')
    },
  },
}
</script>
